var map = {
	"./agital-online-logo.svg": 1164,
	"./benzinpreis-map-desktop.jpg": 1165,
	"./benzinpreis-map-desktop.png": 1284,
	"./heater-house.jpg": 1285,
	"./heater-house.webp": 1286,
	"./photovoltaik-large.webp": 1287,
	"./photovoltaik-small.webp": 1288,
	"./piggy-bank-women.jpg": 1289,
	"./piggy-bank-women.webp": 1290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1163;